import React from "react";
import { FINALIZE_PAGE } from "../../../app/routes";
import { useSelector } from "react-redux";
import { State } from "../../../app/store";
import { HiOutlineShoppingBag } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import EAButton from "../../../app/components/shared/Buttons/EAButton";
import { useNavigate } from "react-router";

interface IProps {
  fullwidth?: boolean;
  onAdditionalAction?: () => void;
}

const BasketNavButton: React.FC<IProps> = ({ fullwidth = true, onAdditionalAction = () => {} }) => {
  const navigate = useNavigate();
  const basketLength = useSelector((state: State) => state.basket.basketLength);
  const { t } = useTranslation();

  const isBasketHasItems = () => {
    if (basketLength > 0) {
      return true;
    } else {
      return false;
    }
  };

  const getTitle = () => {
    if (isBasketHasItems()) {
      return `${t("koszyk")} (${basketLength})`;
    } else {
      return `${t("koszyk")}`;
    }
  };

  const getVariant = () => {
    if (isBasketHasItems()) {
      return "filled";
    } else {
      return "outlined";
    }
  };

  const onClick = () => {
    navigate(FINALIZE_PAGE);
    onAdditionalAction();
  };

  return (
    <EAButton
      title={getTitle()}
      variant={getVariant()}
      onClick={onClick}
      startIcon={<HiOutlineShoppingBag title={t("koszyk")} />}
      fullWidth={fullwidth}
    />
  );
};

export default BasketNavButton;
